module.exports = __webpack_public_path__ + "static/media/emojinew.df007bc7.svg";